import { Injectable } from '@angular/core';
import { MultiTokenUser, TenantTiny } from '@jms/model';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class ShellSelectors {

    public user$ = this.store.select(x => x.shell.user as MultiTokenUser);
    public token$ = this.store.select(x => x.shell.token as string);
    public message$ = this.store.select(x => x.shell.message as string);
    public tenants$ = this.store.select(x => x.shell.user ? x.shell.user.tenants as TenantTiny[] : []);

    constructor(private store: Store<any>) { }
}
